//LX-Produkt Anfrage

//Textblock
document.addEventListener('DOMContentLoaded', () => {

    let variantPicker = document.querySelector("variant-picker");
    let variantPickerType = "picker";

    if (variantPicker == null)
    {
        variantPicker = document.querySelector("variant-selects");
        variantPickerType = "selects";
    }

  const textarea = document.querySelector('[name="contact[Produkt]"]');
  if (!textarea || typeof productData === 'undefined') return;

  function getSelectedVariantId() {
    const el = document.querySelector('form[action^="/cart/add"] input[name="id"]');
    return el ? String(el.value) : null;
  }

  function fillMessage() {
    const selectedId = getSelectedVariantId();
    const variants = productData.variants;

    const v =
      variants.find(x => String(x.id) === selectedId) ||
      variants[0];

    const msg =
`Produkt: ${productData.title}\x0D
Variante: ${v.public_title || v.title || ''}\x0D
Link: ${window.location.origin}/products/${productData.handle}`;


      textarea.value = msg;
    
  }

  // Initial
  fillMessage();


    if (variantPicker) {
      variantPicker.addEventListener("change", () => {
        fillMessage();
      });
    }

});

//Area Needed
document.addEventListener('DOMContentLoaded', () => {

  let yourArea = document.getElementById("areaInput");
 
  const formArea = document.querySelector('[name="contact[Benötigte Anzahl]"');
  if (!yourArea || !formArea || typeof productData === 'undefined') return;

  function fillFormArea() {
    formArea.value = yourArea.value + " m²";
  };

  if (yourArea) {
    yourArea.addEventListener("change", () => {
      fillFormArea();
    });
  }

});


//Disable Filters
document.addEventListener("DOMContentLoaded", () => {

  function updateVariantInputs() {
    document.querySelectorAll(".variant-selects--box input").forEach(input => {
      input.disabled = input.classList.contains("disabled");
    });
  }

  // Initial beim Laden ausführen
  updateVariantInputs();

  // Auf Änderungen im Container reagieren
  document.querySelectorAll(".variant-selects--box").forEach(box => {
    box.addEventListener("change", updateVariantInputs);
  });

});